<template>
  <div class="content_all2" id="account_app">
    <div class="content_box" v-if="!$route.meta.keepAliveSub">
      <div class="list_box w500">
        <div class="y_ititle"><i class="fa fa-user mr5" aria-hidden="true"></i>會員登入</div>
        <div class="mt5 mb5">
          <input name="" type="text" class="input_style" placeholder="帳號" v-model="account">
        </div>
        <div class="mt5 mb5">
          <input name="" type="password" class="input_style" placeholder="密碼" v-model="password">
        </div>
        <div class="mt5 mb5">
          <vue-recaptcha ref="recaptcha" @verify="onVerify" sitekey="6LervDYUAAAAAGFkOwdryvivr3SOXgxDt9505Dop"></vue-recaptcha>
        </div>
        <div class="tomi mt15">
          <button type="submit" class="btn_m" @click="loginClick">登入</button>
          <router-link :to="{ name: 'forpass'}">
            <button type="submit" class="btn_n">忘記密碼</button>
          </router-link>
            <button type="submit" class="btn_m"  v-if="showOption" @click="SSOLoginClick">SSO登入申請新帳號</button>
        </div>
      </div>
    </div>
    <router-view v-if="$route.meta.keepAliveSub"></router-view>
  </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import { API, serverProtocol } from '@/assets/project_setting/config';
import { ShowMessage, Message, RentStatusCode } from '@/assets/library/axiosErrorHandler';
import VueRecaptcha from 'vue-recaptcha';


export default {
  name: 'account_app',
  components: {
    VueRecaptcha
  },
  data() {
    return {
      account: '',
      password: '',
      verifycode: '',
      yearOption: [],
      showOption: false,
    };
  },
  created() {
    this.getYearOption()
  },
  methods: {
    onSubmit: function() {
      this.$refs.invisibleRecaptcha.execute()
    },
    onVerify: function(response) {
      this.verifycode = response
      console.log(this.verifycode)
    },
    getYearOption() {
      axios.get(API.rent_yearoption)
        .then(response => {
          this.yearOption = response.data.filter(data => {
            return data.trash !== 1;
          });
        })
        .then(() => {
          this.checkYearOption()
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    checkYearOption() {
      var dateTime = new Date().getTime();

      var checkYear = this.yearOption.filter(data => {
        var beginTime = new Date(data.beginTime).getTime(),
          endTime = new Date(data.endTime).getTime();

        if (beginTime <= dateTime && dateTime <= endTime) {
          return true
        } else {
          return false
        }
      })
      if (checkYear[0]) {
        this.showOption = true
      }
    },
    checkAccount() {
      if (!this.account) {
        throw new Error('請輸入帳號');
      }
    },
    checkPassword() {
      if (!this.password) {
        throw new Error('請輸入密碼');
      }
    },
    verify() {
      if (!this.verifycode) {
        throw new Error('請勾選驗證');
      }
    },
    loginClick() {

      try {
        this.checkAccount()
        this.checkPassword();
        this.verify();
      } catch (error) {
        alert(error.message);
        return;
      }

      let form = new FormData();
      this.$Loading.start();
      form.append('account', this.account);
      form.append("password", this.password);
      axios.post(API.rent_login, form, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          console.log(response.data)

          sessionStorage.clear();
          sessionStorage.setItem('TokenID', response.data.tokenId);
          sessionStorage.setItem('Role', response.data.role);
          sessionStorage.setItem('locale', 'CH');
          sessionStorage.setItem('Account', response.data.account);
          sessionStorage.setItem('YearUserId', response.data.id);
          sessionStorage.setItem('UnitName', response.data.unitName);
          sessionStorage.setItem('ContactName', response.data.contactName);
          sessionStorage.setItem('TeamType', response.data.teamType);
          sessionStorage.setItem('TeamTypeOther', response.data.teamTypeOther);
          sessionStorage.setItem('UnitType', response.data.unitType);
          if (JSON.parse(response.data.role)['RENT'].includes('YEARUSER')) {
            this.$router.replace({ name: 'manage' });
          } else {
            alert('帳號錯誤');
          }
        })
        .catch(error => {
          //例外處理
          let statusCode = parseInt(error.response.data.statusCode);
          for (let props in RentStatusCode) {
            if (statusCode === RentStatusCode[props]) {
              ShowMessage(Message[props][sessionStorage.locale]);
            }
          }
        });
    },
    SSOLoginClick() {
      if (serverProtocol == 'http://') {
        alert('請使用 https:// 安全連線。');
      } else {
        var url = 'https://adfs.ntu.edu.tw/adfs/ls/?wa=wsignin1.0&wtrealm={0}&wctx=NTU_RENT&wct={1}Z';
        url = url.replace('{0}', encodeURIComponent(API.rent_ssoapply));
        url = url.replace('{1}', encodeURIComponent(moment().format("Y-MM-DD[CST]HH:mm:ss")));
        document.location.href = url;
      }
    }
  },
}

</script>
<style lang="scss">
#account_app {
  .code {
    background-image: url(/../static/bg_1.jpg);
    font-family: Arial;
    font-style: italic;
    color: #a3a3a3;
    font-size: 22px;
    border: 0;
    padding: 2px 3px;
    letter-spacing: 3px;
    font-weight: bolder;
    cursor: pointer;
    width: 130px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    vertical-align: middle;
    user-select: none;
    display: inline-block;
    margin-left: 10px;
  }
  .vile {
    a {
      text-decoration: none;
      font-size: 14px;
      color: #fff;
      font-weight: 500;
    }
  }
}

</style>



// WEBPACK FOOTER //
// AccountApp.vue?3efe4fa1